/** 원문 스타일을 보존하고 읽기 전용 본문의 고정 크기만 공통 크기로 보정한다. */
export function buildContentFontSizeRules(root: HTMLElement, selector: string): string {
  const bodySize = getComputedStyle(root).fontSize;
  if (!bodySize || !Number.isFinite(parseFloat(bodySize))) return '';
  const rules: string[] = [];
  const visit = (parent: Element, path: string) => {
    Array.from(parent.children).forEach((element, index) => {
      // 제목·레이블·조작 UI와 이미지의 시각적 위계는 그대로 둔다.
      if (element.matches('h1,h2,h3,h4,h5,h6,button,input,textarea,select,label,svg,img,video,iframe,style,script,.blue-title-label,.separator-text,[role="button"],[role="status"]')) return;
      const current = `${path} > :nth-child(${index + 1})`;
      const size = getComputedStyle(element).fontSize;
      if (size && size !== bodySize) {
        // 인라인 !important도 표시 단계에서만 덮어쓰며 색상/굵기 등은 건드리지 않는다.
        rules.push(`${current}{font-size:var(--promotion-reading-size,16px) !important;}`);
      }
      visit(element, current);
    });
  };
  visit(root, selector);
  return rules.join('\n');
}
